import { createFileRoute } from "@tanstack/react-router";

import SelfServeSignupVerifyPage from "@/features/auth/pages/self-serve-signup-verify";
import { AuthProvider } from "@/providers/auth.provider";

interface SelfServeSignupVerifySearchParams {
  token?: string;
}

export const Route = createFileRoute("/(auth)/self-serve-signup/verify")({
  component: () => (
    <AuthProvider>
      <main role="main" aria-label="Self-serve signup email verification page" className="min-h-screen w-full">
        <SelfServeSignupVerifyPage />
      </main>
    </AuthProvider>
  ),
  validateSearch: (search: Record<string, unknown>): SelfServeSignupVerifySearchParams => ({
    token: search.token as string | undefined,
  }),
});
